import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.loadingVouchers, action) => {
  switch (action.type) {
    case types.BEGIN_LOAD_VOUCHERS:
      return true;
    case types.FINISH_LOAD_VOUCHERS:
      return false;

    default:
      return state;
  }
};
